import React, { useState, useEffect, useRef } from "react";
import moment from "moment";
import { useParams, useHistory } from "react-router-dom";
import Aux from "../../../hoc/Auxilliary";
import { Typography, Button, Grid } from "@material-ui/core/";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector, useDispatch } from "react-redux";
import localizedStrings from "../../../utils/localize";
import {
  getApplicantStatus,
  getApplicationProspectiveData,
  getProspectiveApplicationData,
  getContactForApplicationForm,
  getApplications,
  getTranscriptData,
  getPaymentPage,
  getOptionList,
  getStateProvinceList,
  getAdmissionCategoryList,
  CreateNewApplicantionRecord,
  updateContactForApplication,
  updateOtherInfoContactForApplication,
  updateApplicationData,
  updateHighSchoolInfo,
  updatePostSchoolInfo,
  updateTranscriptData,
  updateAcknowledgement,
  updatePaymentInfo,
  saveCouponCode,
  getCountryList,
  getRecruiterList,
  getAcademicPeriod,
  getUSBProgram,
  getAreaOfInterestData,
  getPreviousSchoolData,
  clearCouponCode,
  clearCouponCodeData,
  checkPaymentIsDone,
} from "../../../reduxSlices/applicationSlice";
import MessageIndicator from "../../SnackBar";
import { isObjectEmpty, formatDate } from "../../../utils/general";
import AllFormData from "./formData";
import FormBuilder from "../../FormBuilder";
import ApplicationFirstPage from "./ApplicationFirstPage";
import FormStyle from "./prospective.module.css";
import FormHeader from "../../FormHeader";
import { validateApplicationForm } from "../../../helpers/validateApplicationForm";
import Page6 from "./Page6";
import Page7 from "./Page7";
import Page8 from "./Page8";
import Page10 from "./Page10";
import Page11 from "./Page11";
import MonerisPaymentPage from "./MonerisPaymentPage";
import {
  getTranslationsPage3,
  getTranslationsPage3PartOne,
  getTranslationsPage3PartTwo,
} from "./languageTranslation/Page3";
import {
  getTranslationsPage2,
  getTranslationsPage2Address,
  getTranslationsPage2Telephone,
} from "./languageTranslation/Page2";
import {
  getTranslationsPage4,
  getTranslationsPage4AreaofInterest,
} from "./languageTranslation/Page4";
import {
  getTranslationsPage5,
  getTranslationsPage5PartTwo,
  getTranslationsPage5PartThree,
} from "./languageTranslation/Page5";
import { getTranslationsPage8 } from "./languageTranslation/Page8";
import { getTranslationsPage9 } from "./languageTranslation/Page9";
import { getTranslationsPage6 } from "./languageTranslation/Page6";
import { getTranslationsPage7 } from "./languageTranslation/page7";
import { dateLogic } from "../../../helpers/dateLogic";

const useStyles = makeStyles((theme) => ({
  classHeaderFont: {
    fontSize: "1.1rem",
    fontWeight: 800,
    flex: 1,
  },
  formDesign: {
    width: "98%",
    margin: "0 auto",
  },
  bottomButtons: {
    paddingLeft: "32rem",
    [theme.breakpoints.down("lg")]: {
      paddingLeft: "24rem",
    },
    [theme.breakpoints.down("md")]: {
      paddingLeft: "12rem",
    },
    [theme.breakpoints.down("sm")]: {
      paddingLeft: "4rem",
    },
    [theme.breakpoints.down("xs")]: {
      paddingLeft: "4rem",
    },
    marginBottom: theme.spacing(8),
    [theme.breakpoints.down("xs")]: {
      marginBottom: theme.spacing(12),
    },
  },
  classFont1: {
    fontSize: "1.8rem",
    fontWeight: 500,
    flex: 1,
    lineHeight: 2,
  },
  paymentMessage: {
    padding: "7rem 17rem",
    fontWeight: 700,
    fontSize: "18px",
    [theme.breakpoints.down("md")]: {
      padding: "4rem 6rem",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "2rem 2rem",
      fontSize: "16px",
    },
    [theme.breakpoints.down("xs")]: {
      padding: "1.5rem 1rem",
      fontSize: "16px",
    },
  },
}));

var formJson = {};

const ApplicationPage = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const classes = useStyles(props);
  const { applicantId, applicationId } = useParams();
  const [FormData, setFormData] = useState(AllFormData);
  const [displayMessage, setDisplayMessage] = useState("");
  const [dateErrorMessage, setDateErrorMessage] = useState("");
  const [studyPermitIssueDateError, setStudyPermitIssueDateError] =
    useState(false);
  const [primaryDetails, setPrimaryDetails] = useState(FormData.primaryDetails);
  const [nameCitizenshipDetails, setNameCitizenshipDetails] = useState(
    FormData.nameCitizenshipDetails,
  );
  const [addressContactDetails, setAddressContactDetails] = useState(
    FormData.addressContactDetails,
  );
  const [telephoneDetails, setTelephoneDetails] = useState(
    FormData.telephoneDetails,
  );
  const [otherInformation, setOtherInformation] = useState(
    FormData.otherInformation,
  );
  const [otherInformationPart, setOtherInformationPart] = useState(
    FormData.otherInformationPart,
  );
  const [otherInformationRecruitment, setOtherInformationRecruitment] = useState(
    FormData.otherInformationRecruitment,
  );
  
  const [program, setProgram] = useState(FormData.program);
  const [areasofInterestPartOne, setAreasofInterestPartOne] = useState(
    FormData.areasofInterestPartOne,
  );

  const [highSchoolInfo, setHighSchoolInfo] = useState(FormData.highSchoolInfo);
  const [highSchoolInfoPartTwo, setHighSchoolInfoTwo] = useState(
    FormData.highSchoolInfoPartTwo,
  );
  const [highSchoolInfoPartThree, setHighSchoolInfoThree] = useState(
    FormData.highSchoolInfoPartThree,
  );

  const [postSecondaryInfo, setPostSecondaryInfo] = useState(
    FormData.postSecondaryInfo,
  );
  const [postSecondaryInfoparttwo, setPostSecondaryInfoparttwo] = useState(
    FormData.postSecondaryInfoparttwo,
  );
  const [postSecondaryInfoPartThree, setPostSecondaryInfoPartThree] = useState(
    FormData.postSecondaryInfoPartThree,
  );
  const [postSecondaryInfoPartFour, setPostSecondaryInfoPartFour] = useState(
    FormData.postSecondaryInfoPartFour,
  );

  const [grade12, setGrade12] = useState(FormData.grade12);

  const [applicationFee, setApplicationFee] = useState(FormData.applicationFee);
  const [transactionInfo, setTransactionInfo] = useState(
    FormData.transactionInfo,
  );

  const [acknowledgement, setAcknowledgement] = useState(
    FormData.acknowledgement,
  );
  const couponsExist = useSelector(
    (state) => state.applicationData.couponsExist,
  );

  const [prospectiveApplication, setProspectiveApplication] = useState([]);
  const [disabledNextValue, setDisabledNextValue] = useState(true);
  const [disabledSaveValue, setDisabledSaveValue] = useState(false);
  const [disabledPrevValue, setDisabledPrevValue] = useState(false);

  const [key, setKey] = useState(0);
  const [redirect, setRedirect] = useState(false);
  const [jsonData, setJsonData] = useState(formJson);
  const [applicationJsonData, setApplicationJsonData] = useState(formJson);
  const [transcriptJsonData, setTranscriptJsonData] = useState(formJson);
  const [page6Details, setPage6Details] = useState({
    postSecondaryInfo: FormData.postSecondaryInfo,
    postSecondaryInfoparttwo: FormData.postSecondaryInfoparttwo,
    postSecondaryInfoPartThree: FormData.postSecondaryInfoPartThree,
    postSecondaryInfoPartFour: FormData.postSecondaryInfoPartFour,
  });
  const [page7Details, setPage7Details] = useState({
    grade12: FormData.grade12,
  });

  const domesticStatuses = [943240000, 943240004, 943240001, 943240005];
  const internationalStatuses = [943240002, 943240003, 943240006];
  const usbVisaStatus = [943240000, 943240001, 943240005];

  for (let key in primaryDetails) {
    formJson[key] = primaryDetails[key].value;
  }
  for (let key in nameCitizenshipDetails) {
    formJson[key] = nameCitizenshipDetails[key].value;
  }
  for (let key in addressContactDetails) {
    formJson[key] = addressContactDetails[key].value;
  }
  for (let key in telephoneDetails) {
    formJson[key] = telephoneDetails[key].value;
  }
  for (let key in otherInformation) {
    formJson[key] = otherInformation[key].value;
  }
  for (let key in otherInformationPart) {
    formJson[key] = otherInformationPart[key].value;
  }
  for (let key in otherInformationRecruitment) {
    formJson[key] = otherInformationRecruitment[key].value;
  }
  for (let key in program) {
    formJson[key] = program[key].value;
  }
  for (let key in areasofInterestPartOne) {
    formJson[key] = areasofInterestPartOne[key].value;
  }

  for (let key in highSchoolInfo) {
    formJson[key] = highSchoolInfo[key].value;
  }
  for (let key in highSchoolInfoPartTwo) {
    formJson[key] = highSchoolInfoPartTwo[key].value;
  }
  for (let key in highSchoolInfoPartThree) {
    formJson[key] = highSchoolInfoPartThree[key].value;
  }

  for (let key in postSecondaryInfo) {
    formJson[key] = postSecondaryInfo[key].value;
  }
  for (let key in postSecondaryInfoparttwo) {
    formJson[key] = postSecondaryInfoparttwo[key].value;
  }
  for (let key in postSecondaryInfoPartThree) {
    formJson[key] = postSecondaryInfoPartThree[key].value;
  }
  for (let key in postSecondaryInfoPartFour) {
    formJson[key] = postSecondaryInfoPartFour[key].value;
  }
  for (let key in grade12) {
    formJson[key] = grade12[key].value;
  }
  for (let key in applicationFee) {
    formJson[key] = applicationFee[key].value;
  }
  for (let key in transactionInfo) {
    formJson[key] = transactionInfo[key].value;
  }
  for (let key in acknowledgement) {
    formJson[key] = acknowledgement[key].value;
  }
  const [event, setEvent] = useState({
    isEvent: false,
    message: "",
    showSnackbar: false,
  });
  const [error, setError] = useState({
    isError: false,
    message: "",
    showSnackbar: false,
  });
  const prospectiveData = useSelector(
    (state) => state.applicationData.applicationData,
  );
  const fetchApplicationId = useSelector(
    (state) => state.applicationData.applicationId,
  );

  const contactprospectiveData = useSelector(
    (state) => state.applicationData.contactprospectiveData,
  );
  const applicationResultData = useSelector(
    (state) => state.applicationData.applicationJsonData,
  );
  const applicantStatus = useSelector(
    (state) => state.applicationData.applicantStatus,
  );
  const errorMessage = useSelector(
    (state) => state.applicationData.errorMessage,
  );

  const errorStatusCode = useSelector(
    (state) => state.applicationData.errorStatusCode,
  );

  const countryList = useSelector(
    (state) => state.applicationData.countryList.countries,
  );

  const recruiterList = useSelector(
    (state) => state.applicationData.recruiterList,
  );
  const academicPeriod = useSelector(
    (state) => state.applicationData.academicPeriod,
  );
   const stateProvinceList = useSelector(
    (state) => state.applicationData.stateProvinceList,
  );

  const usbProgram = useSelector((state) => state.applicationData.usbProgram);
  const admissionCategoryList = useSelector(
    (state) => state.applicationData.admissionCategoryList,
  );

  const previousSchoolData = useSelector(
    (state) => state.applicationData.previousSchoolData,
  );
  const transcriptResultData = useSelector(
    (state) => state.applicationData.transcriptData,
  );

  const showPaymentPage = useSelector(
    (state) => state.applicationData.showPaymentPage,
  );
  const paymentIsDone = useSelector(
    (state) => state.applicationData.checkPaymentIsDone,
  );

  const language = useSelector((state) => state.language.language);
  localizedStrings.setLanguage(language);

  useEffect(() => {
    localizedStrings.setLanguage(language);
  }, [language]);

   useEffect(() => {
      window.scrollTo(0, 0);
    }, [key]);
    
  useEffect(() => {
    const newAcknowledgement = { ...acknowledgement };
    newAcknowledgement.usb_esignature.elementConfig.label =
      localizedStrings.application.esignature;
    newAcknowledgement.usb_applicationsubmitteddate.elementConfig.label =
      localizedStrings.application.date;
    setAcknowledgement(newAcknowledgement);
  }, [language]);

  useEffect(() => {
    if (!isObjectEmpty(errorMessage) && errorMessage !== undefined) {
      if (errorStatusCode === 401) {
        let event = {
          isEvent: false,
          message: "Session Expired",
          showSnackbar: true,
        };
        setEvent(event);
        setTimeout(() => {
          handelLogout();
        }, 1600);
      } else {
        let event = {
          isEvent: false,
          message: errorMessage,
          showSnackbar: true,
        };
        setEvent(event);
      }
    }
  }, [errorMessage, errorStatusCode]);

  useEffect(() => {
    let entity = "ses_application";
    let attributename = "usb_admissioncategory";
    dispatch(getAdmissionCategoryList(entity, attributename));
  }, [dispatch]);

  useEffect(() => {
    if (isObjectEmpty(transcriptResultData?.length) > 0) {
      setTranscriptJsonData(transcriptResultData);
    }
  }, [transcriptResultData]);

  useEffect(() => {
    if (admissionCategoryList?.length != 0) {
      const transformed = admissionCategoryList?.map(
        ({ value: displayValue, attributevalue: value }) => ({
          displayValue: displayValue,
          value,
        }),
      );
      const newProgram = { ...program };
      newProgram.usb_admissioncategory.elementConfig.options = transformed;
    }
  }, [admissionCategoryList]);

  useEffect(() => {
    dispatch(
      getApplicantStatus(window.localStorage.getItem("x-auth-contactId")),
    );
    dispatch(getCountryList());
    dispatch(getRecruiterList());
  }, [dispatch]);

  useEffect(() => {
    if (isObjectEmpty(applicationResultData.length) > 0) {
      setApplicationJsonData(applicationResultData);
    }
    if (isObjectEmpty(contactprospectiveData.length) > 0) {
      setJsonData({
        ...contactprospectiveData,
        usb_currentstudent: applicationResultData?.usb_currentstudent,
        // If recruiter is null/undefined in DB, default to empty string so "Sélectionner" shows
        _ses_recruiter_value:
          applicationResultData?._ses_recruiter_value ?? "",
      });
    }
  }, [contactprospectiveData, applicationResultData]);

  useEffect(() => {
    if (applicantId) {
      setKey(1);
    }
  }, [applicantId]);

  useEffect(() => {
    if (applicationJsonData?._ses_academicperiodid_value) {
      dispatch(getUSBProgram(applicationJsonData?._ses_academicperiodid_value));
    }
    if (applicationJsonData?.usb_schooltype) {
      dispatch(getPreviousSchoolData(applicationJsonData?.usb_schooltype));
    }
  }, [applicationJsonData]);

  useEffect(() => {
    if (key === 0 || key === 1 || key === 2 || key === 3 || key === 8) {
      dispatch(
        getApplicantStatus(window.localStorage.getItem("x-auth-contactId")),
      );
    }
     if (key === 3) {
      dispatch(
        getAcademicPeriod(
          window.localStorage.getItem("citizenshipstatus"),
          window.localStorage.getItem("usb_currentstudent"),
          jsonData.usb_visastatus,
        ),
      );
    }
  }, [key]);
// console.log(jsonData.usb_visastatus,"jsonData.usb_visastatus")
  const applicantIdValue = applicantId
    ? applicantId
    : applicantStatus?.ses_applicantstatus?.ses_applicantid;

  const applicationIdValue = applicationId ? applicationId : fetchApplicationId;
  useEffect(() => {
    if (!isObjectEmpty(applicantStatus?.ses_applicantstatus)) {
      if (applicantIdValue && applicationIdValue) {
        dispatch(getApplicationProspectiveData(applicantIdValue));
        dispatch(getProspectiveApplicationData(applicantIdValue));
        dispatch(getContactForApplicationForm(applicantIdValue,applicationIdValue));
        if (key === 3) {
          dispatch(getAreaOfInterestData(applicationIdValue));
        }
      }
    }
  }, [applicantStatus]);
  useEffect(() => {
    if (applicantIdValue) {
      if (key === 0 || key === 1 || key === 2 || key === 3 || key === 8) {
        dispatch(getContactForApplicationForm(applicantIdValue,applicationIdValue));
      }
    }
    if (applicationIdValue || key) {
      const schoolLevelMap = {
        2: 284210001,
        4: 284210001,
        5: 284210002,
      };
      const schoolLevel = schoolLevelMap[key] || 284210002;

      if (applicationIdValue !== undefined) {
        dispatch(checkPaymentIsDone(applicationIdValue));
        dispatch(getPaymentPage(applicationIdValue));
        if (
          key == 1 ||
          key === 2 ||
          key === 3 ||
          key === 4 ||
          key === 5 ||
          key === 7
        ) {
          dispatch(getApplications(applicationIdValue, schoolLevel));
        }
      }

      if (key === 6) {
        dispatch(getTranscriptData(applicationIdValue));
      }
    }
  }, [applicationIdValue, key]);

  useEffect(() => {
    if (event.message === "Success") {
      setDisplayMessage(localizedStrings.general.success);
    } else if (event.message === "Something Went Wrong") {
      setDisplayMessage(localizedStrings.general.somethingwentwrong);
    } else if (event.message === "Application fee not found for the specified criteria") {
      setDisplayMessage('Application fee not found for the specified criteria');
    }
  }, [event]);
  // language Transalations
  useEffect(() => {
    //Page 2
    const newNameCitizenshipDetails = { ...nameCitizenshipDetails };
    const newAddressContactDetails = { ...addressContactDetails };
    const newTelephoneDetails = { ...telephoneDetails };
    setNameCitizenshipDetails(
      getTranslationsPage2(newNameCitizenshipDetails, localizedStrings),
    );
    setAddressContactDetails(
      getTranslationsPage2Address(newAddressContactDetails, localizedStrings),
    );
    setTelephoneDetails(
      getTranslationsPage2Telephone(newTelephoneDetails, localizedStrings),
    );
    // Page 3
    const newOtherInformation = { ...otherInformation };
    const newOtherInformationPart = { ...otherInformationPart };
    const newOtherInformationRecruitment = { ...otherInformationRecruitment };
    setOtherInformation(
      getTranslationsPage3(newOtherInformation, localizedStrings),
    );
    setOtherInformationPart(
      getTranslationsPage3PartOne(newOtherInformationPart, localizedStrings),
    );
   setOtherInformationRecruitment(
      getTranslationsPage3PartTwo(newOtherInformationRecruitment, localizedStrings),
    );
    // Page 4
    const newProgram = { ...program };
    const newAreasofInterestPartOne = { ...FormData.areasofInterestPartOne };
    setProgram(
      getTranslationsPage4(newProgram, admissionCategoryList, localizedStrings),
    );
    setAreasofInterestPartOne(
      getTranslationsPage4AreaofInterest(
        newAreasofInterestPartOne,
        localizedStrings,
      ),
    );

    // Page 5
    const newHighSchoolInfo = { ...highSchoolInfo };
    const newHighSchoolInfoPartTwo = { ...highSchoolInfoPartTwo };
    const newHighSchoolInfoPartThree = { ...highSchoolInfoPartThree };
    setHighSchoolInfo(
      getTranslationsPage5(newHighSchoolInfo, localizedStrings),
    );
    setHighSchoolInfoTwo(
      getTranslationsPage5PartTwo(newHighSchoolInfoPartTwo, localizedStrings),
    );
    setHighSchoolInfoThree(
      getTranslationsPage5PartThree(
        newHighSchoolInfoPartThree,
        localizedStrings,
      ),
    );
    const newApplicationFee = { ...applicationFee };
    setApplicationFee(
      getTranslationsPage8(newApplicationFee, localizedStrings),
    );

    // Page 6
    setPage6Details(
      getTranslationsPage6({ ...page6Details }, localizedStrings),
    );
    //Page 7
    setPage7Details(
      getTranslationsPage7({ ...page7Details }, localizedStrings),
    );

    // Page 9
    const newTransactionInfo = { ...transactionInfo };
    setTransactionInfo(
      getTranslationsPage9(newTransactionInfo, localizedStrings),
    );
  }, [language, admissionCategoryList]);

  useEffect(() => {
    const newNameCitizenshipDetails = { ...nameCitizenshipDetails };
    const newAddressContactDetails = { ...addressContactDetails };
    const newOtherInformation = { ...otherInformationRecruitment };
    const newProgram = { ...program };

    if (countryList && countryList?.length > 0) {
      const cert = countryList.map((country) => ({
        displayValue: country.ses_countryname,
        value: country.ses_countrynameid,
      }));
      newAddressContactDetails._ses_countryofresidence_value.elementConfig.options =
        cert;
      newNameCitizenshipDetails._usb_countryofcitizenship_value.elementConfig.options =
        cert;
      newNameCitizenshipDetails._usb_countryofbirth_value.elementConfig.options =
        cert;
    }

    if(stateProvinceList && stateProvinceList?.length > 0){
       // Desired order from screenshot
       const desiredOrder = [
        // Canada (alphabetical)
        "AB","BC","MB","NB","NL","NS","NT","NU","ON","PE","QC","SK","YT",
        // USA States (alphabetical)
        "AL","AK","AR","AZ","CA","CO","CT","DC","DE","FL","GA","HI","IA","ID","IL","IN","KS","KY","LA","MA","MD","ME","MI","MN","MO","MS","MT","NC","ND","NE","NH","NJ","NV","NM","NY","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VT","VA","WA","WI","WV","WY",
        // Territories and Military
        "AS","FM","GU","MH","MP","PR","PW","VI","AA","AE","AP",
        // Other
        "Other"
      ];

       const state = stateProvinceList
        .map((pro) => ({
          displayValue: pro.value,
          value: pro.attributevalue,
        }))
        .sort((a, b) => {
          const aCode = (a.displayValue || "").toUpperCase();
          const bCode = (b.displayValue || "").toUpperCase();
          const aIdx = desiredOrder.indexOf(aCode);
          const bIdx = desiredOrder.indexOf(bCode);

          // Items that are not in desiredOrder fall back to alphabetical but after known ones
          const normAIdx = aIdx === -1 ? Number.MAX_SAFE_INTEGER : aIdx;
          const normBIdx = bIdx === -1 ? Number.MAX_SAFE_INTEGER : bIdx;

          if (normAIdx !== normBIdx) return normAIdx - normBIdx;
          return aCode.localeCompare(bCode, "en", { sensitivity: "base", numeric: true });
        });
      newAddressContactDetails.ses_stateorprovince.elementConfig.options =
        state;
    }

    if (recruiterList && recruiterList?.length > 0) {
      // Sort recruiters alphabetically by name, excluding the "Sélectionner" option
      const sortedRecruiters = recruiterList
        .filter((recruiter) => recruiter.ses_recruiterid !== "") // Exclude the "Sélectionner" option
        .sort((a, b) => a.ses_recruitername.localeCompare(b.ses_recruitername, 'fr', { numeric: true }))
        .map((recruiter) => ({
          displayValue: recruiter.ses_recruitername,
          value: recruiter.ses_recruiterid,
        }));
      
      // Add the "Sélectionner" option at the beginning
      const selectOption = {
        displayValue: "Sélectionner",
        value: "",
      };
      
      newOtherInformation._ses_recruiter_value.elementConfig.options =
        [selectOption, ...sortedRecruiters];
    }
    if (academicPeriod && academicPeriod?.length > 0) {
      const academic = academicPeriod.map((academic) => ({
        displayValue: academic.ses_academicperiod,
        value: academic.ses_academicperiodid,
      }));
      newProgram._ses_academicperiodid_value.elementConfig.options = academic;
    }
 
  }, [countryList, recruiterList, academicPeriod,stateProvinceList]);

  useEffect(() => {
    const newProgram = { ...program };
    if (usbProgram && usbProgram?.length > 0) {
      const usbProgramData = usbProgram.map((program) => ({
        displayValue: program.ses_certificationprogramname,
        value: program._usb_program_value,
      }));
      
      // Add "Sélectionner" option for the second program choice only
      const selectOption = {
        displayValue: "Sélectionner",
        value: "",
      };
      
      newProgram._ses_certificationprogramid_value.elementConfig.options =
        usbProgramData;
      newProgram._usb_certificationprogramid_value.elementConfig.options =
        [selectOption, ...usbProgramData];
      setProgram(newProgram);
    }
  }, [usbProgram, language, admissionCategoryList]);

  useEffect(() => {
    if (previousSchoolData && previousSchoolData?.length > 0) {
      const previousschool = previousSchoolData.map((program) => ({
        displayValue: program.ses_previousschool,
        value: program.ses_previousschoolid,
      }));
      if (key === 4) {
        const newHighSchoolInfo = { ...highSchoolInfo };
        newHighSchoolInfo.usb_schoolname0.elementConfig.options =
          previousschool;
        newHighSchoolInfo.usb_schoolname1.elementConfig.options =
          previousschool;
        newHighSchoolInfo.usb_schoolname2.elementConfig.options =
          previousschool;

        setHighSchoolInfo(newHighSchoolInfo);
      }
      // Page 6
      if (key === 5) {
        const newPostSecondaryPartTwo = { ...postSecondaryInfoparttwo };
        newPostSecondaryPartTwo.usb_secondaryschoolname0.elementConfig.options =
          previousschool;
        newPostSecondaryPartTwo.usb_secondaryschoolname1.elementConfig.options =
          previousschool;
        setPostSecondaryInfoparttwo(newPostSecondaryPartTwo);
      }
    }
  }, [previousSchoolData]);
  useEffect(() => {
    const validateForm = validateApplicationForm(
      key,
      jsonData,
      applicationJsonData,
      transcriptJsonData,
      couponsExist,
      disabledSaveValue,
    );
 // TEMP FIX
    // if (key == 1) {
    //   if (
    //     jsonData.usb_studypermitexpirydate !== "" &&
    //     jsonData.usb_studypermitexpirydate !== null &&
    //     jsonData.usb_studypermitissuedate !== "" &&
    //     jsonData.usb_studypermitissuedate !== null
    //   ) {
    //     const dateError =
    //       new Date(jsonData.usb_studypermitexpirydate) >
    //       new Date(jsonData.usb_studypermitissuedate);
    //     setStudyPermitIssueDateError(!dateError);
    //   }
    // }
    setDisabledNextValue(validateForm);
    setDisabledSaveValue(validateForm);
    if(key === 3 && academicPeriod?.length === 0){
      setDisabledNextValue(true);
      setDisabledSaveValue(true);
    }
    window.localStorage.setItem(
      "usb_currentstudent",
      jsonData.usb_currentstudent,
    );
    if (key === 4) {
      const msg = dateLogic(applicationJsonData, 5, localizedStrings);
      setDateErrorMessage(msg);
      if (msg !== "") {
        setDisabledSaveValue(true);
        setDisabledNextValue(true);
      }
    }
  }, [
    jsonData,
    applicationJsonData,
    transcriptJsonData,
    key,
    couponsExist,
    language,
    academicPeriod,
  ]);

  useEffect(() => {
    const entity = "ses_application";
    const attributename = "ses_applicationstatus";
    dispatch(getOptionList(entity, attributename));
    dispatch(getStateProvinceList('contact', 'ses_stateorprovince'));
    
  }, [dispatch]);
  useEffect(() => {
    // Set Memory Variable for Citizenship Status
    if (domesticStatuses.includes(jsonData.usb_visastatus)) {
      window.localStorage.setItem("citizenshipstatus", "Domestic");
      window.localStorage.setItem("applicationfee", "100 $");
    } else if (internationalStatuses.includes(jsonData.usb_visastatus)) {
      window.localStorage.setItem("citizenshipstatus", "International");
      window.localStorage.setItem("applicationfee", "130 $");
    }

    const newNameCitizenshipDetails = { ...nameCitizenshipDetails };
    const newAddressContactDetails = { ...addressContactDetails };
    const newTelephoneDetails = { ...telephoneDetails };
    const newOtherInformation = { ...otherInformation };
    const newOtherInformationPart = { ...otherInformationPart };
    const newProgram = { ...program };

    if (jsonData.usb_allownametobeeditedbyapplicant === 943240001) {
      newNameCitizenshipDetails.firstname.elementConfig.disabled = true;
      newNameCitizenshipDetails.lastname.elementConfig.disabled = true;
      newNameCitizenshipDetails.middlename.elementConfig.disabled = true;
      newOtherInformation.birthdate.elementConfig.disabled = true;
    } else if (jsonData.usb_allownametobeeditedbyapplicant !== 943240001) {
      newNameCitizenshipDetails.firstname.elementConfig.disabled = false;
      newNameCitizenshipDetails.lastname.elementConfig.disabled = false;
      newNameCitizenshipDetails.middlename.elementConfig.disabled = false;
      newOtherInformation.birthdate.elementConfig.disabled = false;
    }
    newNameCitizenshipDetails.usb_mostrecentpreviousapplicationyear.elementConfig.display =
      jsonData.usb_previouslyapplied === true ? "block" : "none";
     newNameCitizenshipDetails.usb_currentstudent.elementConfig.display =
      jsonData.usb_previouslyapplied === true ? "block" : "none";
  
    newTelephoneDetails.ses_optinfortextmessages.elementConfig.display =
      jsonData.mobilephone !== null &&
      jsonData.mobilephone !== "" &&
      jsonData.mobilephone !== undefined
        ? "block"
        : "none";


    // Define a general helper function to set display properties for any object
    const setDisplay = (object, fields, displayValue) => {
      fields.forEach((field) => {
        if (object[field]) {
          // Ensure the field exists
          object[field].display = displayValue;
        }
      });
    };

    const isVisaStatus943240004 =
      jsonData.usb_visastatus === 943240004 ||
      jsonData.usb_visastatus === 943240003 ||
      jsonData.usb_visastatus === 943240002;
    const isVisaStatus943240006 = jsonData.usb_visastatus === 943240006;

    // Common fields for both visa statuses
    setDisplay(
      newNameCitizenshipDetails,
      ["usb_passport", "usb_passportexpirydate"],
      isVisaStatus943240004 || isVisaStatus943240006 ? "block" : "none",
    );

    // Fields specific to visa status 943240004
    setDisplay(
      newNameCitizenshipDetails,
      [
        "usb_studypermitnumber",
        "usb_studypermitissuedate",
        "usb_studypermitexpirydate",
      ],
      isVisaStatus943240004 ? "block" : "none",
    );

    const isResidenceCountryMatch = [
      "c3f83658-1116-ee11-9cbe-000d3af4f17d", // Canada
      "01f93658-1116-ee11-9cbe-000d3af4f17d", // Etats-Unis
    ].includes(jsonData._ses_countryofresidence_value);
    // Address visibility: show province/postal only for Canada/US
    setDisplay(
      newAddressContactDetails,
      ["ses_stateorprovince", "address1_postalcode"],
      isResidenceCountryMatch ? "block" : "none"
    );
 newAddressContactDetails.ses_stateorprovince.elementConfig.display =
      isResidenceCountryMatch ? "block" : "none";
    // Toggle labels and required flags for address fields per requirements
    // address1_line1 and address1_city are always required
    newAddressContactDetails.address1_line1.elementConfig.label =
      `${localizedStrings.applicationpage.street} *`;
    newAddressContactDetails.address1_line2.elementConfig.label =
      `${localizedStrings.applicationpage.streetapt}`;

    newAddressContactDetails.address1_city.elementConfig.label =
      `${localizedStrings.applicationpage.city} *`;

    newAddressContactDetails.ses_stateorprovince.elementConfig.label =
      isResidenceCountryMatch
        ? `${localizedStrings.applicationpage.stateprovince} *`
        : `${localizedStrings.applicationpage.stateprovince}`;

    newAddressContactDetails.address1_postalcode.elementConfig.label =
      isResidenceCountryMatch
        ? `${localizedStrings.applicationpage.postalcode} *`
        : `${localizedStrings.applicationpage.postalcode}`;

    if (key === 3) {
      newProgram.usb_admissioncategory.elementConfig.display =
        usbVisaStatus.includes(jsonData.usb_visastatus) ? "block" : "none";
    }
    if (key === 4) {
      const newHighSchoolInfo = { ...highSchoolInfo };
      const newHighSchoolInfoPartThree = { ...highSchoolInfoPartThree };

      setDisplay(
        newHighSchoolInfo,
        ["usb_metnumber"],
        applicationJsonData.usb_graduatefromhighschoolincurrentyear === true
          ? "block"
          : "none",
      );

      newHighSchoolInfo.usb_schoolname0.elementConfig.display =
        applicationJsonData.usb_schooltype === 943240000 ? "block" : "none";
      newHighSchoolInfo.usb_schoolname1.elementConfig.display =
        applicationJsonData.usb_schooltype === 943240001 ? "block" : "none";
      newHighSchoolInfo.usb_schoolname2.elementConfig.display =
        applicationJsonData.usb_schooltype === 943240002 ? "block" : "none";

      newHighSchoolInfoPartThree.usb_graduationdate.elementConfig.display =
        applicationJsonData.usb_graduate === true ? "block" : "none";
    }
    if (key === 5) {
      const newPostSecondaryInfoPartTwo = { ...postSecondaryInfoparttwo };
      const newPostSecondaryInfoPartFour = { ...postSecondaryInfoPartFour };
      newPostSecondaryInfoPartTwo.usb_secondaryschoolname0.elementConfig.display =
        applicationJsonData.usb_schooltype === 943240003 ? "block" : "none";

      newPostSecondaryInfoPartTwo.usb_secondaryschoolname1.elementConfig.display =
        applicationJsonData.usb_schooltype === 943240004 ? "block" : "none";

      newPostSecondaryInfoPartFour.usb_graduationdate.elementConfig.display =
        applicationJsonData.usb_currentdegreestatus === 943240001
          ? "block"
          : "none";
      const isCurrentdegreestatus =
        applicationJsonData.usb_currentdegreestatus === 943240001;

      newPostSecondaryInfoPartFour.end_date_month.elementConfig.label =
        isCurrentdegreestatus
          ? `${localizedStrings.applicationpage.monthwithoutrequired}*`
          : `${localizedStrings.applicationpage.monthwithoutrequired}`;
      newPostSecondaryInfoPartFour.end_date_year.elementConfig.label =
        isCurrentdegreestatus
          ? `${localizedStrings.applicationpage.yearwithoutrequired}*`
          : `${localizedStrings.applicationpage.yearwithoutrequired}`;
      setPostSecondaryInfoparttwo(newPostSecondaryInfoPartTwo);
      setPostSecondaryInfoPartFour(newPostSecondaryInfoPartFour);
    }

    setNameCitizenshipDetails(newNameCitizenshipDetails);

    // Handling display for newOtherInformationPart fields based on usb_indigenousancestry
  newOtherInformationPart.usb_indigenousancestry.elementConfig.display =
    jsonData[
      "_usb_countryofbirth_value@OData.Community.Display.V1.FormattedValue"
    ] === "Canada"
      ? "block"
      : "none";
  const displayValue = jsonData.usb_indigenousancestry === 1 ? "block" : "none";
  newOtherInformationPart.usb_indigenousancestrytype.elementConfig.display =
    displayValue;
    setOtherInformationPart(newOtherInformationPart);

    const displayVisibleminority =
      jsonData.usb_visibleminority === 943240010 ? "block" : "none";
    newOtherInformation.usb_othervisibleminority.display =
      displayVisibleminority;
    setOtherInformation(newOtherInformation);
    // Update address details after label/display changes
    setAddressContactDetails(newAddressContactDetails);
    setTelephoneDetails(newTelephoneDetails);
  }, [jsonData, applicationJsonData, key]);

  useEffect(() => {
    if (prospectiveData.length > 0) {
      const data = [...prospectiveData];
      data.sort(
        (item1, item2) => new Date(item2.createdon) - new Date(item1.createdon),
      );
      setProspectiveApplication(data);
    }
  }, [prospectiveData]);

  const handleCheck = (event, eventName) => {
    const newJsonData = { ...jsonData };
    newJsonData[eventName] = event.target.checked;

    setJsonData(newJsonData);
  };
  const handleMultipleCheck = (event, eventName, value) => {
    const newJsonData = { ...applicationJsonData };
    let currentValues = newJsonData[eventName]
      ? newJsonData[eventName].split(",")
      : [];

    const stringValue = value.toString();
    if (event.target.checked) {
      if (!currentValues.includes(stringValue)) {
        currentValues.push(stringValue);
      }
    } else {
      currentValues = currentValues.filter((v) => v !== stringValue);
    }
    newJsonData[eventName] = currentValues.join(",");

    setApplicationJsonData(newJsonData);
  };

  const handelDateChange = (event, eventName) => {
    const filtterFormDataCopy = { ...jsonData };
    filtterFormDataCopy[eventName] = moment(event).format("YYYY-MM-DD");
    setJsonData(filtterFormDataCopy);
  };

  const handelDateChangeEditable = (date, value, eventName) => {
    const filtterFormDataCopy = { ...jsonData };
    filtterFormDataCopy[eventName] = value;
    setJsonData(filtterFormDataCopy);
  };

  const handleSave = () => {
    const schoolLevelMap = {
      2: 284210001,
      4: 284210001,
      5: 284210002,
    };
    const schoolLevel = schoolLevelMap[key] || 284210001;
    let applicantionRecordData = {
      ses_applicantid: applicantIdValue,
      usb_inititalagreement: jsonData.usb_inititalagreement,
      ses_applicationstatus:
        applicantStatus?.ses_applicantstatus?.ses_applicantstatus,
      ses_applicantname: applicantStatus?.ses_applicantstatus?.fullname,
    };
    function validateDate(date) {
      return date === "Invalid date" ? null : formatDate(date);
    }
    let updateContact = {
      address1_city: jsonData.address1_city,
      address1_composite: jsonData.address1_composite,
      address1_line1: jsonData.address1_line1,
      address1_line2: jsonData.address1_line2,
      address1_postalcode: jsonData.address1_postalcode,
      ses_stateorprovince: jsonData.ses_stateorprovince,
      emailaddress1: jsonData.emailaddress1,
      emailaddress3: jsonData.emailaddress3,
      firstname: jsonData.firstname,
      lastname: jsonData.lastname,
      middlename: jsonData.middlename,
      ses_preferredname: jsonData.ses_preferredname,
      mobilephone: jsonData.mobilephone,
      usb_formername: jsonData.usb_formername,
      usb_maidenname: jsonData.usb_maidenname,
      _usb_countryofbirth_value: jsonData._usb_countryofbirth_value,
      usb_otherlegalfirstnames: jsonData.usb_otherlegalfirstnames,
      home2: jsonData.home2,
      business2: jsonData.business2,
      ses_optinfortextmessages: jsonData.ses_optinfortextmessages,
      usb_passport: jsonData.usb_passport,
      usb_passportexpirydate:
        jsonData.usb_passportexpirydate === null
          ? null
          : validateDate(jsonData.usb_passportexpirydate),
      usb_studypermitexpirydate:
        jsonData.usb_studypermitexpirydate === null
          ? null
          : validateDate(jsonData.usb_studypermitexpirydate),
      usb_studypermitissuedate:
        jsonData.usb_studypermitissuedate === null
          ? null
          : validateDate(jsonData.usb_studypermitissuedate),
      usb_studypermitnumber: jsonData.usb_studypermitnumber,
      usb_visastatus: jsonData.usb_visastatus,
      _ses_countryofresidence_value: jsonData._ses_countryofresidence_value,
      _usb_countryofcitizenship_value: jsonData._usb_countryofcitizenship_value,
      usb_currentstudent: applicationJsonData.usb_currentstudent,
       usb_previouslyapplied: jsonData.usb_previouslyapplied,
      usb_mostrecentpreviousapplicationyear:
        jsonData.usb_mostrecentpreviousapplicationyear,
      usb_sourcedata :
      `Nom légal: ${jsonData.lastname || ''}
       Prénom légal: ${jsonData.firstname || ''}
       Autres prénoms légaux: ${jsonData.middlename || ''}
       Adresse courriel: ${jsonData.emailaddress1 || ''}
       Téléphone cellulaire: ${jsonData.mobilephone || ''}
       ${new Date().toISOString()}`
        };

    let updateOtherInfoContact = {
      birthdate: jsonData.birthdate,
      gendercode: jsonData.gendercode,
      mshied_firstgeneration: jsonData.mshied_firstgeneration,
      usb_nativelanguage: jsonData.usb_nativelanguage,
      usb_areyouavisibleminority: jsonData.usb_areyouavisibleminority,
      usb_othervisibleminority: jsonData.usb_othervisibleminority,
      _ses_recruiter_value:
        applicationJsonData._ses_recruiter_value === "" ? null : applicationJsonData._ses_recruiter_value,
      usb_indigenousancestry: jsonData.usb_indigenousancestry,
      usb_indigenousancestrytype: jsonData.usb_indigenousancestrytype,
    };
    if (key === 0) {
      dispatch(CreateNewApplicantionRecord(applicantionRecordData));
    }
    if (key === 1) {
      dispatch(
        updateContactForApplication(
          updateContact,
          window.localStorage.getItem("x-auth-contactId"),
          applicationIdValue,
        ),
      );
    }
    if (key === 2) {
      dispatch(
        updateOtherInfoContactForApplication(
          updateOtherInfoContact,
          window.localStorage.getItem("x-auth-contactId"),
          applicationIdValue,
        ),
      );
    }
    if (key === 3) {
      const applicationData = {
        _ses_academicperiodid_value:
          applicationJsonData._ses_academicperiodid_value,
        _ses_certificationprogramid_value:
          applicationJsonData._ses_certificationprogramid_value,
        _usb_certificationprogramid_value:
          applicationJsonData._usb_certificationprogramid_value,
        usb_admissioncategory: applicationJsonData.usb_admissioncategory,
        usb_areasofinterestandservices:
          applicationJsonData.usb_areasofinterestandservices,
      };
      dispatch(updateApplicationData(applicationData, applicationIdValue));
    }
    if (key === 4) {
      const {
        usb_schooltype,
        usb_schoolname0,
        usb_schoolname1,
        usb_schoolname2,
      } = applicationJsonData;
      let schoolname, schooltype;

      switch (usb_schooltype) {
        case 943240005:
          schoolname = null;
          schooltype = 943240005;
          break;
        case 943240000:
          schoolname = usb_schoolname0;
          schooltype = 943240000;
          break;
        case 943240001:
          schoolname = usb_schoolname1;
          schooltype = 943240001;
          break;
        case 943240002:
          schoolname = usb_schoolname2;
          schooltype = 943240002;
          break;
        default:
          schoolname = null;
      }
      const highSchoolData = {
        usb_graduatefromhighschoolincurrentyear:
          applicationJsonData.usb_graduatefromhighschoolincurrentyear,
        usb_metnumber:
          applicationJsonData.usb_graduatefromhighschoolincurrentyear === true
            ? applicationJsonData.usb_metnumber
            : null,
        usb_graduate: applicationJsonData.usb_graduate,
        usb_startdate: `${applicationJsonData.start_date_month}/${applicationJsonData.start_date_year}`,
        usb_enddate: `${applicationJsonData.end_date_month}/${applicationJsonData.end_date_year}`,
        usb_graduationdate: [null, undefined, "null"].includes(applicationJsonData.usb_graduationdate) ? "" : applicationJsonData.usb_graduationdate,
         usb_addtionalcoursescomment: [null, undefined, "null"].includes(applicationJsonData.usb_addtionalcoursescomment)
          ? ""
          : `${applicationJsonData.usb_addtionalcoursescomment}`,
        _usb_schoolname_value: schoolname,
        usb_schooltype: schooltype,
        schoolLevel: schoolLevel,
      };
      dispatch(updateHighSchoolInfo(highSchoolData, applicationIdValue));
    }
    
    if (key === 7 && applicationJsonData.applicationOptions === "Coupon") {
      const applicationFeeData = {
        usb_couponcode: applicationJsonData.usb_couponcode,
      };
      dispatch(saveCouponCode(applicationFeeData, applicationIdValue));
    }
    if (key === 9) {
      const acknowledgementData = {
        usb_termsaccepted: applicationJsonData.usb_termsaccepted,
        usb_esignature: applicationJsonData.usb_esignature,
        usb_applicationsubmitteddate:
          applicationJsonData.usb_applicationsubmitteddate,
        ses_applicationstatus: 284210001,
      };
      dispatch(updateAcknowledgement(acknowledgementData, applicationIdValue));
    }
  };

  const textFieldChangeHandler = (event, key) => {
    const filtterFormDataCopy = { ...jsonData };
    filtterFormDataCopy[event.target.name] = event.target.value;
    setJsonData(filtterFormDataCopy);
  };

  const textFieldChangeHandlerForApplication = (event, key) => {
    const filtterFormDataCopy = { ...applicationJsonData };
    filtterFormDataCopy[event.target.name] = event.target.value;
    setApplicationJsonData(filtterFormDataCopy);
  };
  const handleChangeforApplication = (event) => {
    const filtterFormDataCopy = { ...applicationJsonData };
    const eventName = event.target.name;
    const eventValue = event.target.value;
    if (
      key === 4 &&
      eventName === "usb_graduatefromhighschoolincurrentyear" &&
      eventValue === true
    ) {
      filtterFormDataCopy["usb_schooltype"] = 943240000;
      filtterFormDataCopy["usb_graduate"] = false;
    }
    if (
      key === 4 &&
      eventName === "usb_graduatefromhighschoolincurrentyear" &&
      eventValue === false
    ) {
      filtterFormDataCopy["usb_schooltype"] = null;
    }
    if (eventName === "usb_schooltype") {
      dispatch(getPreviousSchoolData(eventValue));
    }
    filtterFormDataCopy[eventName] = eventValue;

    if (eventName === "_ses_academicperiodid_value") {
      filtterFormDataCopy[eventName] = eventValue;
      filtterFormDataCopy["_ses_certificationprogramid_value"] = null;
      filtterFormDataCopy["_usb_certificationprogramid_value"] = null;
    }
    if (eventName === "usb_graduate") {
      filtterFormDataCopy[eventName] = eventValue;
      filtterFormDataCopy["usb_graduationdate"] =
        eventValue === true ? applicationJsonData.usb_graduationdate : null;
    }

    setApplicationJsonData(filtterFormDataCopy);
  };

  const handleChange = (event, key) => {
    const filtterFormDataCopy = { ...jsonData };

    const eventName = event.target.name;
    const eventValue = event.target.value;
    const applicationfiltterFormDataCopy = { ...applicationJsonData };
    filtterFormDataCopy[eventName] = eventValue;

    if (
      eventName === "usb_currentstudent" ||
      eventName === "_ses_recruiter_value"
    ) {
      applicationfiltterFormDataCopy[eventName] = eventValue;
    }

    if (eventName === "usb_visastatus") {
      if (domesticStatuses.includes(eventValue)) {
        filtterFormDataCopy["amountdue"] = "100 $";
      } else if (internationalStatuses.includes(eventValue)) {
        filtterFormDataCopy["amountdue"] = "130 $";
      }
    }

    // Hidden for now
    // if (
    //   eventName === "usb_otherphonenumber" ||
    //   eventName === "usb_otherphone"
    // ) {
    //   const countryName = countryCodes.findOne(
    //     "countryCode",
    //     event.target.value
    //   );
    //   if (filtterFormDataCopy[eventName] === undefined) {
    //     filtterFormDataCopy[eventName] =
    //       "+" + countryName.countryCallingCode + "-";
    //   } else {
    //     const arr = filtterFormDataCopy[eventName].split("-");
    //     filtterFormDataCopy[eventName] =
    //       "+" + countryName.countryCallingCode + "-" + arr[arr.length - 1];
    //   }
    // }

    setJsonData(filtterFormDataCopy);
    setApplicationJsonData(applicationfiltterFormDataCopy);
  };

  const handleClose = () => {
    if (event.showSnackbar) {
      let eventCopy = { ...event };
      eventCopy.showSnackbar = false;
      setEvent(eventCopy);
    } else {
      let errorCopy = { ...error };
      errorCopy.showSnackbar = false;
      setError(errorCopy);
    }
  };

  const handlePrevClick = () => {
    if (key === 0) {
      history.push("/prospective/landingpage");
    }
    if (
      key === 9 &&
      !applicationJsonData.usb_graduatefromhighschoolincurrentyear
    ) {
      setKey((prevState) => prevState - 3);
    } else if (
      key === 9 &&
      applicationJsonData.usb_graduatefromhighschoolincurrentyear
    ) {
      setKey((prevState) => prevState - 2);
    }
    if (
      key === 8 &&
      !applicationJsonData.usb_graduatefromhighschoolincurrentyear
    ) {
      setKey((prevState) => prevState - 2);
    } else if (
      key === 8 &&
      applicationJsonData.usb_graduatefromhighschoolincurrentyear
    ) {
      setKey((prevState) => prevState - 1);
    }
    if (
      key === 7 &&
      !applicationJsonData.usb_graduatefromhighschoolincurrentyear
    ) {
      setKey((prevState) => prevState - 2);
    } else {
      setKey((prevState) => prevState - 1);
    }

    if (key === 7) {
      dispatch(clearCouponCode());
      dispatch(clearCouponCodeData());
    }
    setDisabledNextValue(false);
    setDisabledSaveValue(false);
  };
  const handleNextClick = () => {
    handleSave();
    setDisabledNextValue(true);
    setTimeout(() => {
      if (
        key === 5 &&
        !applicationJsonData.usb_graduatefromhighschoolincurrentyear &&
        paymentIsDone === true &&
        showPaymentPage === false
      ) {
        setKey((prevState) => prevState + 4);
        return setDisabledNextValue(true);
      }
      if (
        key === 5 &&
        !applicationJsonData.usb_graduatefromhighschoolincurrentyear
      ) {
        setKey((prevState) => prevState + 2);
        setDisabledNextValue(true);
      }

      if (key === 6 && showPaymentPage === true) {
        return setKey((prevState) => prevState + 1);
      }

      if (key === 6 && showPaymentPage === false) {
        return setKey((prevState) => prevState + 3);
      }

      if (
        key === 7 &&
        applicationJsonData.applicationOptions === "Coupon" &&
        couponsExist === true
      ) {
        setKey((prevState) => prevState + 2);
        dispatch(clearCouponCode());
        dispatch(clearCouponCodeData());
      }
      if (key === 7 && applicationJsonData.applicationOptions === "Fee") {
        setKey((prevState) => prevState + 1);
      }
      if (
        key === 0 ||
        key === 1 ||
        key === 2 ||
        key === 3 ||
        key === 4 ||
        (key === 5 &&
          applicationJsonData.usb_graduatefromhighschoolincurrentyear) ||
        key === 6 ||
        key === 8 ||
        key === 9 ||
        key === 10
      ) {
        setKey((prevState) => prevState + 1);
        setDisabledNextValue(true);
      }
    }, 2000);
  };

  const monerisPaymentRef = useRef();

  const handleMakePayment = () => {
    // Call the function from the child component via ref
    if (monerisPaymentRef.current) {
      monerisPaymentRef.current.handleMakePayment();
    }
  };
  return (
    <Aux>
      <MessageIndicator
        open={event.showSnackbar || error.showSnackbar}
        message={displayMessage}
        handleClose={handleClose}
      />
      <Grid container>
        <Grid item container xs={11} sm={10} style={{ margin: "0 auto" }}>
          {key === 0 && (
            <>
              {/* Application first page */}
              <Grid>
                <ApplicationFirstPage />
                <Grid container item className={classes.formDesignMain}>
                  <Grid
                    direction="column"
                    container
                    item
                    style={{ alignSelf: "flex-start" }}
                  >
                    <div className={classes.formDesign}>
                      <FormBuilder
                        formDetails={FormData.primaryDetails}
                        value={jsonData}
                        handleCheck={handleCheck}
                      />
                    </div>
                  </Grid>
                </Grid>

                <br />
              </Grid>
            </>
          )}
          {key === 1 && (
            <Grid>
              <Grid style={{ padding: "0 2.5rem" }}>
                <Typography component="div" className={classes.classFont1}>
                  Formulaire de demande d’admission de l’USB
                </Typography>
                <Typography
                  component="div"
                  className={classes.classFont}
                  style={{ marginTop: "1rem" }}
                >
                  Tu peux sauvegarder ta demande à tout moment et y revenir
                  ultérieurement pour la compléter. Les boutons situés en bas de
                  chaque page te permettront d’enregistrer les informations
                  affichées sur la page et de naviguer en avant et en arrière
                  dans la demande. Lorsque tu cliques sur le bouton PAGE
                  SUIVANTE, les données sont enregistrées avant l’ouverture de
                  la page suivante.
                  <Typography
                    component="div"
                    className={classes.classFont}
                    style={{ marginTop: "1rem" }}
                  >
                    Les champs marqués d’un astérisque (*) doivent être remplis
                    avant que les données de la page puissent être enregistrées
                    et que tu puisses passer à la prochaine page de la demande.
                  </Typography>
                </Typography>

                <Typography component="div" className={FormStyle.formContainer}>
                  <FormHeader
                    name={
                      localizedStrings.applicationpage.nameandcitizenshipstatus
                    }
                  />
                  <div className={classes.formDesign}>
                    <FormBuilder
                      formDetails={FormData.nameCitizenshipDetails}
                      value={jsonData}
                      handleChange={handleChange}
                      changed={textFieldChangeHandler}
                      handelDateChange={handelDateChange}
                    />
                  </div>
                  {studyPermitIssueDateError &&
                    nameCitizenshipDetails.usb_studypermitexpirydate.display ===
                      "block" && (
                      <p style={{ color: "red", padding: "10px" }}>
                        {
                          localizedStrings.applicationpage
                            .studyPermitIssueDateError
                        }
                      </p>
                    )}
                </Typography>

                <Typography component="div" className={FormStyle.formContainer}>
                  <FormHeader
                    name={
                      localizedStrings.applicationpage.addresscontactinformation
                    }
                  />
                  <div className={classes.formDesign}>
                    <FormBuilder
                      formDetails={FormData.addressContactDetails}
                      value={jsonData}
                      handleChange={handleChange}
                      changed={textFieldChangeHandler}
                    />
                  </div>
                </Typography>
                 <Typography component="div" className={FormStyle.formContainer}>
                  <FormHeader
                    name={
                      localizedStrings.applicationpage.telephoneDetails
                    }
                    header={
                       localizedStrings.applicationpage.telephoneHeader
                    }
                  />
                  
                  <div className={classes.formDesign}>
                    <FormBuilder
                      formDetails={FormData.telephoneDetails}
                      value={jsonData}
                      handleChange={handleChange}
                      changed={textFieldChangeHandler}
                    />
                  </div>
                </Typography>
              </Grid>
            </Grid>
          )}

          {key === 2 && (
            <Grid xs={12}>
               <Grid style={{ padding: "0 2.5rem" }}>
                  <Typography
                    component="div"
                    className={FormStyle.formContainer}
                  >
                    <FormHeader
                      name={localizedStrings.applicationpage.otherInformation}
                    />
                    <div className={classes.formDesign}>
                      <FormBuilder
                        formDetails={FormData.otherInformation}
                        value={jsonData}
                        handleChange={handleChange}
                        changed={textFieldChangeHandler}
                        handelDateChange={handelDateChange}
                        handelDateChangeEditable={handelDateChangeEditable}
                      />
                      <Typography
                        component="div"
                        className={classes.classFont}
                        style={{ marginTop: "1rem" }}
                      >
                        {jsonData[
                          "_usb_countryofbirth_value@OData.Community.Display.V1.FormattedValue"
                        ] === "Canada" && (
                          <>
                            {localizedStrings.application.otherinfo} <br />
                          </>
                        )}
                        <FormBuilder
                          formDetails={FormData.otherInformationPart}
                          value={jsonData}
                          handleChange={handleChange}
                          changed={textFieldChangeHandler}
                        />
                      </Typography>
                    </div>
                  </Typography>
                  <Typography
                    component="div"
                    className={FormStyle.formContainer}
                  >
                    <FormHeader
                      name={
                        localizedStrings.applicationpage.recruitmentAgentsHeader
                      }
                    />
                    <div className={classes.formDesign}>
                      <FormBuilder
                        formDetails={FormData.otherInformationRecruitment}
                        value={jsonData}
                        handleChange={handleChange}
                        changed={textFieldChangeHandler}
                      />
                    </div>
                  </Typography>
                </Grid>
            </Grid>
          )}

          {key === 3 && (
            <Grid xs={12}>
              <Grid style={{ padding: "0 2.5rem" }}>
                {academicPeriod?.length === 0 && (
                  <div
                    style={{
                      padding: "12px 10px",
                      background: "#efd6e1",
                      color: "black",
                      fontSize: "16px",
                    }}
                  >
                    {localizedStrings.applicationpage.admitterm}
                    <br />
                  </div>
                )}
                <br />
                <Typography component="div" className={FormStyle.formContainer}>
                  <FormHeader name={localizedStrings.applicationpage.program} />
                  <div className={classes.formDesign}>
                    <FormBuilder
                      formDetails={program}
                      value={applicationJsonData}
                      handleChange={handleChangeforApplication}
                    />
                    
                    <br />
                 
                    <FormHeader
                      name={
                        localizedStrings.applicationpage
                          .studentactivitiesandstudentservices
                      }
                    />
                    <Typography
                      component="div"
                      className={classes.classFont}
                      style={{ marginTop: "1rem" }}
                    >
                      {localizedStrings.applicationpage.learningmoreabout}
                    </Typography>
                    <FormBuilder
                      formDetails={FormData.areasofInterestPartOne}
                      value={applicationJsonData}
                      handleMultipleCheck={handleMultipleCheck}
                    />
                  </div>
                </Typography>
              </Grid>
            </Grid>
          )}
          {key === 4 && (
            <Grid xs={12}>
              <Grid style={{ padding: "0 2.5rem" }}>
                <Typography component="div" className={FormStyle.formContainer}>
                  <FormHeader
                    name={
                      localizedStrings.applicationpage
                        .previouseducationhighschool
                    }
                  />
                  <div className={classes.formDesign}>
                    Sur cette page, il faut fournir des informations sur la
                    dernière école secondaire que tu as fréquentée ou que tu
                    fréquentes présentement.
                    <Typography
                      component="div"
                      className={classes.classFont}
                      style={{ marginTop: "1rem" }}
                    >
                      Une copie officielle de ton relevé de notes final et une
                      attestation de réussite (le cas échéant) doivent être
                      soumises. Il demeure de ta responsabilité de t’assurer que
                      l’Université de Saint-Boniface reçoit tous les documents
                      en lien avec ta demande d’admission avant la date limite.
                    </Typography>
                    <br />
                    <FormBuilder
                      formDetails={FormData.highSchoolInfo}
                      value={applicationJsonData}
                      handleChange={handleChangeforApplication}
                      changed={textFieldChangeHandlerForApplication}
                    />
                    {
                      localizedStrings.applicationpage
                        .monthandyeardidyoustartattendingthisschool
                    }
                    <FormBuilder
                      formDetails={FormData.highSchoolInfoPartTwo}
                      value={applicationJsonData}
                      handleChange={handleChangeforApplication}
                      changed={textFieldChangeHandlerForApplication}
                    />
                    {
                      localizedStrings.applicationpage
                        .monthandyeardidyoufinishyourstudiesattheschool
                    }
                    <FormBuilder
                      formDetails={FormData.highSchoolInfoPartThree}
                      value={applicationJsonData}
                      handleChange={handleChangeforApplication}
                      changed={textFieldChangeHandlerForApplication}
                    />
                  </div>
                  {dateErrorMessage && (
                    <p style={{ color: "red", padding: "10px" }}>
                      {dateErrorMessage}
                    </p>
                  )}
                </Typography>
              </Grid>
            </Grid>
          )}
          {key === 5 && (
            <Page6
              applicationJsonData={applicationJsonData}
              formData={page6Details.postSecondaryInfo}
              formDatatwo={page6Details.postSecondaryInfoparttwo}
              formDatathree={page6Details.postSecondaryInfoPartThree}
              formDatafour={page6Details.postSecondaryInfoPartFour}
              setApplicationJsonData={setApplicationJsonData}
              applicationIdValue={applicationIdValue}
              setDisabledNextValue={setDisabledNextValue}
              setDisabledSaveValue={setDisabledSaveValue}
              setDisabledPrevValue={setDisabledPrevValue}
            />
          )}

          {key === 6 && (
            <>
              <Page7
                transcriptJsonData={transcriptJsonData}
                formData={page7Details.grade12}
                setTranscriptJsonData={setTranscriptJsonData}
                applicationIdValue={applicationIdValue}
                setDisabledNextValue={setDisabledNextValue}
                setDisabledSaveValue={setDisabledSaveValue}
                setDisabledPrevValue={setDisabledPrevValue}
              />
            </>
          )}
          {key === 7 && (
            <>
              <Page8
                applicationJsonData={applicationJsonData}
                formData={FormData.applicationFee}
                setApplicationJsonData={setApplicationJsonData}
                applicationIdValue={applicationIdValue}
              />
            </>
          )}

          {key === 8 && (
            <Grid xs={12}>
              <Grid style={{ padding: "0 2.5rem" }}>
                <Typography component="div" className={FormStyle.formContainer}>
                  {jsonData && jsonData?.ticket === "PaymentNotdone" && (
                    <div
                      style={{
                        padding: "7rem 25rem",
                        fontSize: "18px",
                      }}
                    >
                      {" "}
                      <div style={{ fontWeight: 700 }}>
                        {" "}
                        {
                          localizedStrings.applicationpage
                            .monerispaymentwasnotsuccessful
                        }
                      </div>
                      {
                        localizedStrings.applicationpage
                          .monerispaymentwasnotsuccessfultext
                      }{" "}
                      <a href="mailto:admissions@ustboniface.ca">
                        admissions@ustboniface.ca
                      </a>
                      .
                    </div>
                  )}
                  <>
                    {jsonData && jsonData?.ticket !== "PaymentNotdone" && (
                      <FormHeader
                        name={
                          localizedStrings.applicationpage.payapplicationfee
                        }
                      />
                    )}
                    <MonerisPaymentPage
                      jsonData={jsonData}
                      formData={FormData.transactionInfo}
                      setJsonData={setJsonData}
                      ref={monerisPaymentRef}
                      applicationId={applicationIdValue}
                    />
                  </>
                  {jsonData &&
                    jsonData?.ticket !== null &&
                    jsonData.paymentdone === true && (
                      <div className={classes.paymentMessage}>
                        {" "}
                        {localizedStrings.applicationpage.yourpayment}{" "}
                        {jsonData?.amountdue}{" "}
                        {localizedStrings.applicationpage.hasbeenreceived}
                      </div>
                    )}{" "}
                </Typography>
              </Grid>
            </Grid>
          )}
          {key === 9 && (
            <Page10
              applicationJsonData={applicationJsonData}
              formData={FormData.acknowledgement}
              setApplicationJsonData={setApplicationJsonData}
              applicationIdValue={applicationIdValue}
            />
          )}
          {key === 10 && <Page11 />}

          <Grid
            container
            justifyContent="center"
            spacing={2}
            className={classes.bottomButtons}
          >
            {(key === 0 ||
              key === 2 ||
              key === 3 ||
              key === 4 ||
              key === 5 ||
              key === 6 ||
              key === 7 ||
              key === 8 ||
              key === 9) && (
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handlePrevClick}
                  disabled={disabledPrevValue}
                >
                  {localizedStrings.application.back}
                </Button>
              </Grid>
            )}
            {(key === 1 || key === 2 || key === 3 || key === 4 || key == 5) && (
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSave}
                  disabled={disabledSaveValue}
                >
                  {localizedStrings.applicationpage.save}
                </Button>
              </Grid>
            )}
            {key === 9 && (
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleNextClick}
                  disabled={disabledNextValue}
                >
                  {localizedStrings.application.submitmyapplication}
                </Button>
              </Grid>
            )}
            {key === 8 && (
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleMakePayment}
                  disabled={jsonData.paymentdone}
                >
                  {localizedStrings.applicationpage.makeapayment}
                </Button>
              </Grid>
            )}
            {key !== 9 && key !== 10 && (
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  className={
                    disabledNextValue === true
                      ? FormStyle.disabledColor
                      : FormStyle.defaultColor
                  }
                  disabled={disabledNextValue}
                  onClick={handleNextClick}
                >
                  {localizedStrings.application.next}
                </Button>
              </Grid>
            )}
          </Grid>
          <br/><br/><br/>
        </Grid>
      </Grid>
    </Aux>
  );
};

export default ApplicationPage;
